import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=2b9c80e6&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9c80e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b9c80e6')) {
      api.createRecord('2b9c80e6', component.options)
    } else {
      api.reload('2b9c80e6', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=2b9c80e6&scoped=true&", function () {
      api.rerender('2b9c80e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25526uOI11vNK/JS/comp/Accordion.vue"
export default component.exports